var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h5',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('contract.other_regulations.headline')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('contract.other_regulations.paragraph_one')))]),_vm._v(" "),_vm._l((_vm.otherRegulations),function(regulation,index){return _c('p',{key:regulation.id},[_vm._v(_vm._s(("17." + (index+2) + "\t" + (regulation.text))))])}),_vm._v(" "),_c('hr')],2)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/eneforhandler/components/contract/OtherRegulationsOutput.vue?vue&type=template&id=ca884924&
// module id = null
// module chunks = 